import Swiper from "swiper";
import { Navigation } from "swiper/modules";

const carousels = document.querySelectorAll(".carousel-posts-by-tag .posts-by-tag-carousel");

carousels.forEach((slider) => {
    const Carousel  = slider.querySelector(".swiper");
    const prevArrow = slider.querySelector(".swiper-button-prev");
    const nextArrow = slider.querySelector(".swiper-button-next");

    new Swiper(Carousel, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        centerInsufficientSlides: true,
        loop: true,
        watchSlidesProgress: false,
        navigation: { nextEl: nextArrow, prevEl: prevArrow },
        breakpoints: {
            992: {
                slidesPerView: 3,
                spaceBetween: 0,
            },
        },
    });
});
